<template>
	<div>
		<wc-report-navbar></wc-report-navbar>
		<div class="homeBto0"></div>
	</div>
</template>

<script>
	export default{
		name:'WcReport',
		data(){
			return {
				BackisShow:false,
				closeIsShow:false
			}
		},
		methods:{
			getCurPath(){
				var path = this.$route.path;
				if(path=="/report"){
					this.closeIsShow=true;
				}
			},
			
		},
		mounted() {
			this.getCurPath();
		}
	}
</script>

<style>
	.homeBto0{
		width: 100%;
    	height: 51px;
	}
</style>


// WEBPACK FOOTER //
// src/components/report/index/WcReport.vue